<!--
  ~ Copyright (c) 2022 Certusoft, Inc. All Rights Reserved.
  ~
  ~ This SOURCE CODE FILE, which has been provided by Certusoft as part
  ~ of a Certusoft product for use ONLY by licensed users of the product,
  ~ includes CONFIDENTIAL and PROPRIETARY information of Certusoft.
  ~
  ~ USE OF THIS SOFTWARE IS GOVERNED BY THE TERMS AND CONDITIONS
  ~ OF THE LICENSE STATEMENT AND LIMITED WARRANTY FURNISHED WITH
  ~ THE PRODUCT.
  -->

<div id="clik_data_manager" class="container">
    <h4 class="first-header">
        <span>Select a Projects/Tag to use.</span>
    </h4>
    <div class="panel" *ngFor="let clikConfigurationName of clikConfigurationNames">
        <div class="panel-body">
            <app-clik-client-configuration
                [clikConfigurationName]="clikConfigurationName"
                (changeEvent)="emitChange($event)"
            ></app-clik-client-configuration>
        </div>
    </div>
</div>
